import {
  BookOpen,
  Camera,
  Dribbble,
  Facebook,
  Github,
  Globe2,
  Instagram,
  Linkedin,
  MessageCircle,
  Music,
  Palette,
  Share2,
  Twitter,
  Video,
  Youtube,
  type LucideIcon
} from 'lucide-react';
import { cn } from 'v5/platform/dom/cn';

const SOCIAL_PLATFORM_LUCIDE_ICONS: Record<string, LucideIcon> = {
  behance: Palette,
  discord: MessageCircle,
  dribbble: Dribbble,
  facebook: Facebook,
  github: Github,
  instagram: Instagram,
  linkedin: Linkedin,
  medium: BookOpen,
  other: Share2,
  rednote: Globe2,
  soundcloud: Music,
  spotify: Music,
  tiktok: Video,
  twitter: Twitter,
  vimeo: Video,
  vsco: Camera,
  youtube: Youtube
};

export function ResourceSocialPlatformIcon({
  platform,
  className
}: {
  platform: string;
  className?: string;
}) {
  const normalized = platform.trim().toLowerCase() || 'other';
  const Icon = SOCIAL_PLATFORM_LUCIDE_ICONS[normalized] ?? Globe2;

  return (
    <Icon
      className={cn('size-4 shrink-0 text-fg-muted', className)}
      aria-hidden
    />
  );
}
